// extracted by mini-css-extract-plugin
module.exports = {"bidCountText":"VehicleCardBidCount_bidCountText__RzGeS"};